module.exports = __webpack_public_path__ + "resources/img/img_secuve_tos.615fa0d220b16a3c04e584211424052c.png";